import { connect, MapStateToProps } from 'react-redux';
import { AppState } from '../../../../types/store';
import {
  getProfileOwnerStats,
  isCurrentUserProfileOwner,
} from '../../../selectors/users';
import { getModuleType } from '../../../selectors/modules';
import {
  getAllInstalledModuleIds,
  getSectionLayoutVersion,
} from '../../../selectors/layout';
import {
  ModuleTypeToStatNameMap,
  ModuleTypeToWidgetComponentMap,
} from './constants';
import { ModuleType } from '../../../../types/modules';
import shortenNumber from '@wix/da-shared-react/pkg/utils/shortenNumber';
import { Props } from './AboutSection';

type StateProps = Pick<Props, 'stats' | 'routes' | 'layoutVersion'>;
type OwnProps = Omit<Props, keyof StateProps>;

const section = 'about';

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  const stats = getProfileOwnerStats(state);
  const isOwner = isCurrentUserProfileOwner(state);
  const routes = getAllInstalledModuleIds(state, section)
    .map(moduleId => {
      const moduleType = getModuleType(state, moduleId);
      if (
        !moduleType ||
        !ModuleTypeToWidgetComponentMap.hasOwnProperty(moduleType)
      ) {
        return undefined;
      }
      const statName = ModuleTypeToStatNameMap[moduleType];
      const statValue = stats[statName];
      const hideItem = !isOwner && statValue === 0;
      if (hideItem) {
        return undefined;
      }
      const formattedCount =
        moduleType !== ModuleType.MY_COMMENTS && // we don't show count for My comment item
        statValue &&
        shortenNumber(statValue);
      const translationKey = `pages.about.navmenu.${moduleType}`;
      return {
        hash: moduleType,
        transKey: translationKey,
        count: formattedCount,
      };
    })
    .filter(route => route) as Props['routes'];
  const layoutVersion = getSectionLayoutVersion(state, section);
  return {
    stats,
    routes,
    layoutVersion,
  };
};

export default connect(mapStateToProps);
